import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import "./index.scss";
import "./registerServiceWorker";

createApp(App).mount("#app");
